module.exports = "<bdb-tp-empty-state \n  is-logo=\"true\" \n  type-logo=\"BDBFULL\" \n  btn-right\n  [errTitle]=\"errTitle\"\n  [errDesc]=\"errorDescription\"\n  [labelBtn]=\"labelBtn\"\n  type-img=\"final-error\" \n  show-icon\n  [desc]=\"descFooter\"\n  (btnClick) = \"onBtnClick()\">\n</bdb-tp-empty-state>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error-page/error-page.component.html
// module id = ./src/app/components/error-page/error-page.component.html
// module chunks = main